import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Sidebar from "../../components/common/Sidebar";
import Navbar from "../../components/common/Navbar";
import Box from "@mui/material/Box";
const sideBarWidth = 270;
const Layout = ({ children, title, description, keywords, author }) => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const protectedNavbar = () => {
    switch (location.pathname) {
      case "/login":
        return null;
      case "/create-account":
        return null;
      default:
        return (
          <Navbar
            sideBarWidth={sideBarWidth}
            handleDrawerToggle={handleDrawerToggle}
          />
        );
    }
  };
  const protectedHeader = () => {
    switch (location.pathname) {
      case "/login":
        return null;
      case "/signup":
        return null;
      default:
        return (
          <Sidebar
            sideBarWidth={sideBarWidth}
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
          />
        );
    }
  };
  const protectedFooter = () => {
    switch (location.pathname) {
      case "/login":
        return null;
      case "/signup":
        return null;
    }
  };
  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <Navbar
          sideBarWidth={sideBarWidth}
          handleDrawerToggle={handleDrawerToggle}
        />
        <Sidebar
          sideBarWidth={sideBarWidth}
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            px: { xs: 1, md: 2 },
            width: { xs: "100%", md: `calc(100% - ${sideBarWidth}px)` },
          }}
        >
          <Helmet>
            <meta charSet="utf-8" />
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content={author} />
            <title>{title}</title>
          </Helmet>
          {protectedNavbar()}
          {protectedHeader()}
          <main>{children}</main>
          {protectedFooter}
        </Box>
      </Box>
    </div>
  );
};

Layout.defaultProps = {
  title: "Born To Win",
  description:
    "Born to Win Global Initiatives is committed to bridging the gap between potential and opportunity for Ethiopians. Through scholarships, jobs and internships, career guidance, donor support, and startup development, we empower individuals and communities to thrive and grow.",
  keywords: "Born To Win,Ethiopian Society,Website,Ethiopia",
  author: "Gedefaye Mengstu",
};

export default Layout;
